import axios from "../axios"

const getExpertPurposeTypeCategoryExpertPurposeTypes = (expertPurposeTypeCategoryId) => {
    return axios.get(`/docflow/purpose-categories/${expertPurposeTypeCategoryId}/types`)
        .then(response => response.data);
}

export default {
    getExpertPurposeTypeCategoryExpertPurposeTypes
}
